// extracted by mini-css-extract-plugin
export default {"cls1":"intZdp5iDu4yX2x915g1","cls2":"OrrUsmaX3gM_AyxIdPFR intZdp5iDu4yX2x915g1","profileBack":"keuGQGmhgB1ZjEzdNs7S"};